<!-- LoadingView.vue -->
<script setup>
import { useWebsiteConfigStore } from '../stores/website/configStore'
import { useI18n } from 'vue-i18n'

// Obtener la función de traducción explícitamente
const { t } = useI18n()

defineProps({
  message: {
    type: String,
    default: 'Loading...'
  }
})

const websiteStore = useWebsiteConfigStore();
</script>

<template>
  <div
    class="login-background"
    :style="websiteStore.config.branding?.background ?
      `background-image: url(${websiteStore.config.branding.background})` : ''"
  >
    <div class="content-wrapper">
      <!-- Logo Section -->
      <div class="logo-container">
        <img
          v-if="websiteStore.config.branding?.logo_desktop"
          :src="websiteStore.config.branding.logo_desktop"
          class="logo"
          alt="Logo"
        />
      </div>

      <!-- Loading Section -->
      <div class="loading-container">
        <div class="loading-bar">
          <div class="loading-progress"></div>
        </div>
        <div class="card">
          <div class="loader">
            <!-- Usar la función t directamente -->
            <p>{{ t('loading.title') }}</p>
            <div class="words">
              <span class="word">{{ t('loading.credentials') }}</span>
              <span class="word">{{ t('loading.resources') }}</span>
              <span class="word">{{ t('loading.games') }}</span>
              <span class="word">{{ t('loading.jackpots') }}</span>
              <span class="word">{{ t('loading.balances') }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import '../assets/styles/main.css';
.card {
    /* color used to softly clip top and bottom of the .words container */
    
    background-color: transparent;
    padding: 1rem 2rem;
    border-radius: 1.25rem;
  }
  .loader {
    color: #0d02e3;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 25px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    height: 35px;
    padding: 10px 10px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    border-radius: 8px;
    position: relative;  /* Hace que respete el z-index */
    z-index: 25;  /* Mayor que la barra y words */
  }

  .words {
    overflow: hidden;
    position: relative;
  }
  .words::after {
    content: "";
    position: absolute;
    inset: 0;
    background: linear-gradient(
      var(--bg-color) 10%,
      transparent 30%,
      transparent 70%,
      var(--bg-color) 90%
    );
    z-index: 20;
  }

  .word {
    display: block;
    height: 100%;
    padding-left: 6px;
    color: #956afa;
    animation: spin_4991 20s infinite;
    position: relative;  /* Hace que respete el z-index */
    z-index: 25;  /* Mayor que la barra y words */
  }

  @keyframes spin_4991 {
    10% {
      -webkit-transform: translateY(-102%);
      transform: translateY(-102%);
    }

    25% {
      -webkit-transform: translateY(-100%);
      transform: translateY(-100%);
    }

    35% {
      -webkit-transform: translateY(-202%);
      transform: translateY(-202%);
    }

    50% {
      -webkit-transform: translateY(-200%);
      transform: translateY(-200%);
    }

    60% {
      -webkit-transform: translateY(-302%);
      transform: translateY(-302%);
    }

    75% {
      -webkit-transform: translateY(-300%);
      transform: translateY(-300%);
    }

    85% {
      -webkit-transform: translateY(-402%);
      transform: translateY(-402%);
    }

    100% {
      -webkit-transform: translateY(-400%);
      transform: translateY(-400%);
    }
  }
  @media (max-width: 480px) {
  /* Ajusta el texto "Cargando" */
  .loader {
    font-size: 18px;
    top: -2px; /* Alinea con la barra */
  }

  /* Ajusta las palabras animadas */
  .words {
    width: 80px; /* Reduce el ancho para móviles */
  }

  .word {
    font-size: 16px; /* Reduce el tamaño en móviles */
  }
}

</style>